import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ACH_DYNAMIC_COMPONENTS } from "src/constants/achEnrollment";

interface AchEnrollmentStepsState {
  activeEnrollmentStep: string;
  showNotificationBanner: boolean;
  noOfOTPAttempts:number;
}

const initialState: AchEnrollmentStepsState = {
  activeEnrollmentStep: ACH_DYNAMIC_COMPONENTS.Authentication,
  showNotificationBanner: false,
  noOfOTPAttempts: 0,
};

const achEnrollmentStepsSlice = createSlice({
  name: "achEnrollment",
  initialState,
  reducers: {
    setActiveAchEnrollmentStep(state, action: PayloadAction<string>) {
      state.activeEnrollmentStep = action.payload;
    },
    incrementOTPAttempts: (state) => {
      state.noOfOTPAttempts += 1;
    },
    resetOTPAttempts: (state) => {
      state.noOfOTPAttempts = 0;
    }
  },
});

export const { setActiveAchEnrollmentStep, incrementOTPAttempts, resetOTPAttempts } = achEnrollmentStepsSlice.actions;

export default achEnrollmentStepsSlice.reducer;
